<seira-sem-dados
	*ngIf="!dados || dados.length === 0; else mapa"></seira-sem-dados>

<ng-template #mapa>
	<div id="mapa-legenda">
		<div class="d-flex">
			<div class="col-12 pe-lg-0 pe-1" style="max-height: 500px">
				<div class="mapa-wrapper">
					<seira-mapa-paraiba-leaflet
						[loading]="isLoading"
						(mapaEmitter)="setupMap($event)"
						[monitoramentoMapa]="map!" />
				</div>
			</div>
		</div>

		<div id="legenda-export">
			<seira-legenda-ndc />
		</div>
	</div>
</ng-template>
